import React from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from "@stripe/stripe-js/pure";
// import CheckoutForm from "./CheckoutForm";
import CheckOutExpired from './CheckOutExpired'
import {STRIPE_KEY} from "../../../config.json";

const stripePromise = loadStripe(STRIPE_KEY);

const PayCardExpired = (props) => (
    <Elements stripe={stripePromise}>
        <CheckOutExpired {...props} />
    </Elements>
);
export default PayCardExpired;
